import type { ReactElement } from "react"
import type { FormProps } from "@gatsby-plugin-generic-page/components/Formily/Formily"
import Formily from "@gatsby-plugin-generic-page/components/Formily/Formily"
import type { Formily as FormilyType } from "@gatsby-plugin-generic-page/fragments/formily"
import ModalTemplateWrapper from "~/components/ModalTemplateWrapper"

export type FormilyFormModalProps = {
  formilyForm: FormilyType
  formAdditionalData?: FormProps["additionalData"]
  isOpen: boolean
  onClose: () => void
}

export default function FormilyFormModal({
  formilyForm,
  formAdditionalData,
  isOpen,
  onClose,
}: FormilyFormModalProps): ReactElement<FormilyFormModalProps> {
  const { formButton, captcha, ...formilyProps } = formilyForm.flatData

  return (
    <ModalTemplateWrapper
      onCloseButtonClick={onClose}
      width="narrow"
      isOpen={isOpen}
      content={
        <Formily
          captchaEnabled={captcha}
          button={formButton}
          onSubmitSuccess={() =>
            setTimeout(() => {
              onClose()
            }, 1000)
          }
          additionalData={formAdditionalData}
          {...formilyProps}
        />
      }
    />
  )
}
